// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"1f344b9e","73":"8558c7da","294":"c8d6a575","341":"445abc83","495":"db84b477","519":"43b200a2","555":"29aa60ce","876":"76806113","913":"57898464","933":"7691fbab","936":"f77392b5","981":"825dc20f"}[chunkId] + ".chunk.js";
};